/**
 * legal — the operating entity behind Orbit, in one place.
 *
 * Orbit is a Wavesync LLC product. Before this file the footers,
 * the email shell and the three policy pages each carried their own
 * hand-typed "Orbit" copyright line, so naming the company meant
 * finding nine strings and hoping none were missed. Everything that
 * states who operates the Service now reads from here.
 *
 * LEGAL_ENTITY is the registered company name and must match the
 * Utah registration exactly — it is the counterparty a customer
 * contracts with in Terms §1 and the controller named in Privacy.
 */

/** The product. */
export const PRODUCT_NAME = 'Orbit';

/** The company that operates it. Must match the state registration. */
export const LEGAL_ENTITY = 'Wavesync LLC';

/** Principal place of business — governing law and the email footer. */
export const LEGAL_STATE = 'Utah';
export const LEGAL_COUNTY = 'Salt Lake County';
export const LEGAL_CITY = 'Salt Lake City, UT';

/**
 * The footer copyright line. Orbit first (it's the mark a visitor
 * recognises), the company second (it's who actually holds the
 * rights). `withReserved` adds the long form for the full marketing
 * footer; compact footers take the short one.
 */
export const copyrightLine = (year: number, withReserved = false): string =>
  `© ${year} ${PRODUCT_NAME} · ${LEGAL_ENTITY}${withReserved ? '. All rights reserved.' : ''}`;
